export default __webpack_public_path__ + "static/amuleto-0f10f9f2fbf3370c15908c3d38690c23.webp";